"use client";
import React from "react";

interface Props {
  text: string;
}

const CategoryDescriptionToggle = ({ text }: Props) => {
  return (
    <div className="bg-gray-50 border border-gray-100 rounded-2xl p-6 mb-10">
      <p
        className="text-gray-600 text-sm leading-relaxed"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {text}
      </p>
      <a
        href="#category-full-description"
        className="mt-2 inline-block text-[11px] font-black text-[#ff912f] uppercase tracking-widest hover:text-[#111318] transition-colors no-underline"
      >
        See More
      </a>
    </div>
  );
};

export default CategoryDescriptionToggle;
